import { Star, Quote } from "lucide-react";

export const Stars = ({ value, onChange, size = "w-4 h-4" }) => (
  <div className="flex gap-1" data-testid="star-rating">
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)} data-testid={`star-${n}`}
        className={onChange ? "p-1.5 -m-1 cursor-pointer transition-transform hover:scale-110" : "cursor-default"} aria-label={`${n} stars`}>
        <Star className={`${size} ${n <= value ? "fill-[#D4AF37] text-[#D4AF37]" : "text-white/25"}`} />
      </button>
    ))}
  </div>
);

export const TestimonialCard = ({ t }) => (
  <div className="lux-card lift p-8 h-full flex flex-col bg-gradient-to-b from-[#3B1152]/50 to-black/40 border-[#D4AF37]/25" data-testid={`testimonial-card-${t.id}`}>
    <Quote className="w-8 h-8 text-[#D4AF37]/70" />
    <p className="mt-5 font-display text-xl leading-relaxed text-white/90 flex-1">“{t.message}”</p>
    <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between">
      <div>
        <p className="font-medium">{t.name}</p>
        {t.service && <p className="text-xs text-white/50 mt-1 tracking-wide">{t.service}</p>}
      </div>
      <Stars value={t.rating} />
    </div>
  </div>
);
